export const CLIENT_DISPATCH_TARGET_APP = "appClient" as const;
export const CLIENT_DISPATCH_TARGET_MASTER = "masterClient" as const;

export type TClientDispatchTarget =
  | typeof CLIENT_DISPATCH_TARGET_APP
  | typeof CLIENT_DISPATCH_TARGET_MASTER;
